export interface OpenPuzzleNeighbors {
  /** Nächstälterer offener Spieltag vor `current`, sonst null. */
  prev: string | null;
  /** Nächstjüngerer offener Spieltag nach `current`, sonst null. */
  next: string | null;
  /** 1-basierte Position von `current` unter den offenen Tagen, null
   *  wenn `current` selbst nicht offen ist. */
  position: number | null;
}

/**
 * Sucht die offenen Nachbar-Tage zu `current`. `dates` muss aufsteigend
 * sortiert sein (so liefert es GET /api/puzzle/open). ISO-Daten lassen
 * sich direkt als String vergleichen.
 */
export function findOpenNeighbors(dates: readonly string[], current: string): OpenPuzzleNeighbors {
  const prev = dates.filter((d) => d < current).at(-1) ?? null;
  const next = dates.find((d) => d > current) ?? null;
  const index = dates.indexOf(current);
  return { prev, next, position: index === -1 ? null : index + 1 };
}
